import BOLayout from '@/pages/back-office/BOLayout';
import TopBanner from '@/components/back-office/TopBanner';
import Pagination from '@/components/back-office/Pagination';
import { useRestaurantsContext } from '@/contexts/RestaurantContext';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Pen from '@/assets/media/SVGComponents/Pen';
import Trash from '@/assets/media/SVGComponents/Trash';
import Modal from '@/components/Modal';
import { toast } from 'react-toastify';

const titleConverter = {
	country: 'Pays',
	region: 'Départements',
	list: 'Liste de départements',
};

const DeliveryZonesList = () => {
	const { selectedRestaurant } = useRestaurantsContext();
	const role = JSON.parse(localStorage.getItem('role'));
	const [fees, setFees] = useState([]);
	const [total, setTotal] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [showModal, setShowModal] = useState(false);
	const [feeId, setFeeId] = useState(null);
	const feesPerPage = 10;
	const navigate = useNavigate();
	const onPageChange = (pageNumber) => setCurrentPage(pageNumber);

	// Pagination
	const indexOfLastFees = currentPage * feesPerPage;
	const indexOfFirstFees = indexOfLastFees - feesPerPage;
	const currentFees = fees?.slice(indexOfFirstFees, indexOfLastFees);

	const handleOpenModal = (e, feeId) => {
		setShowModal(true);
		setFeeId(feeId);
	};

	const handleModalSubmit = async () => {
		try {
			await axios.delete(`${import.meta.env.VITE_API_URL}/api/back-office/delivery-fees/${feeId}/delete`);

			toast.success('Frais de livraisons supprimés avec succès', {
				position: 'top-center',
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				theme: 'colored',
			});

			setShowModal(false);
		} catch (error) {
			console.error('Error deleting delivery fee:', error);
			toast.error('Une erreur est survenue', {
				position: 'top-center',
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				theme: 'colored',
			});
		}

		setTimeout(() => {
			navigate(0);
		}, 1500);
	};

	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${import.meta.env.VITE_API_URL}/api/back-office/delivery-fees`, {
					params: {
						page: currentPage,
						limit: feesPerPage,
					},
				});

				if (response.status === 200) {
					setFees(response.data.delivery_fees);
					setTotal(response.data.total);
				}
			} catch (error) {
				console.error(error);

				toast.error('Une erreur est survenue', {
					position: 'top-center',
					autoClose: 800,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: true,
					theme: 'colored',
				});

				setTimeout(() => (window.location.href = '/back-office/settings/delivery_zones/list'), 1200);
			}
		};
		fetchData();
	}, [selectedRestaurant]);

	return (
		<BOLayout>
			{showModal && (
				<Modal
					type={'danger'}
					title={'Cette action est irréversible'}
					setShowModal={setShowModal}
					handleSubmit={handleModalSubmit}
				/>
			)}

			<div className="mb-12">
				<TopBanner
					role={role}
					showToggle={false}
					hasTopRightButton={false}
					hasEventInfo={false}
					withDescription={false}
					hasOtherButtons={true}
					otherButtons={[
						{ text: 'Créer des frais de de livraison', navigationRoute: '/back-office/settings/frais-de-livraison/creation' },
					]}
				/>
			</div>

			{showModal && (
				<Modal
					type={'danger'}
					title={'Cette action est irréversible'}
					setShowModal={setShowModal}
					handleSubmit={handleModalSubmit}
				/>
			)}

			<div className="text-md font-bold mb-2 flex items-center gap-2">
				<span className="text-white w-8 h-8 rounded-full flex justify-center items-center bg-primary">{total}</span>{' '}
				Liste des frais de livraison
			</div>

			<table className="table table-striped table-bordered table-auto w-full text-center">
				<thead className="border-b border-b-black pb-2 mb-4">
					<tr>
						<th>Nom</th>
						<th>Zone géographique</th>
						<th>Type de zone géographique</th>
						<th>Prix</th>
						<th>Pallier</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					{fees?.map((fee, index) => (
						<tr key={fee.reference || index}>
							<td>{fee.name}</td>
							<td>
								{fee.zones.length > 0
									? fee.zones
										.slice(0, 3)
										.map((zone) => (fee.type === 'region' ? zone.region : zone.zipcode))
										.join(' - ') + (fee.zones.length > 3 ? '...' : '')
									: fee.country}
							</td>
							<td>{titleConverter[fee.type]}</td>
							<td>{fee.price}</td>
							<td>{fee.tier}</td>
							<td className="flex items-center justify-center gap-2">
								<button type="button" onClick={() => navigate(`/back-office/settings/frais-de-livraison/${fee.id}/edition`)}>
									<Pen color="#A2924A" width={40} height={40} />
								</button>

								<button type="button" className="m-2" onClick={(e) => handleOpenModal(e, fee?.id)}>
									<Trash color="#A2924A" width={40} height={40} />
								</button>
							</td>
						</tr>
					))}
				</tbody>
			</table>

			{/* Utilisation du composant Pagination */}
			<Pagination
				currentPage={currentPage}
				totalItems={currentFees?.length}
				itemsPerPage={feesPerPage}
				onPageChange={onPageChange}
			/>

			{fees?.length === 0 && <div className="flex justify-center">Aucun frais de livraison</div>}
		</BOLayout>
	);
};

export default DeliveryZonesList;
